import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, message } from "antd";
import sortBy from "lodash/sortBy";
import "../styles.css";
import useAuthStore from "../../../../stores/useAuthStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import {
  WalletRedeemDrawer,
  GiftCardDrawer,
  CustomerWalletDrawer,
  RefundWalletDrawer,
  SalesRepDrawer,
  StockConfirmationDrawer,
  WalletOtpModal,
  ReturnOptionsModal,
} from "./modals";
import BankTransferDrawer from "./modals/BankTransferDrawer";
import messages from "../../../../errors/messages.en-IN.json";

const PointOfSuperMarketModals = (props) => {
  const {
    amount,
    cart,
    setCart,
    openSalesRep,
    setOpenSalesRep,
    selectedProductInCart,
    isStockModal,
    setIsStockModal,
    addProduct,
    handleCartTotalClick,
    tempCart,
    setTempCart,
    deleteCart,
    deleteProduct,
    posConfig,
    keyboardType,
    setKeyboardType,
    salesRepValue,
    setSalesRepValue,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    selectedSaleTypeData,
    showPayments,
    setShowPayments,
    setShowPaymentMethods,
    setStartIndex,
    processOrder,
    upsertPOSLog,
    documentTypes,
    searchInputRef,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    currenciesData,
    setCurrenciesData,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    handleCashPayment,
    showConfirm,
    handleAmount,
    requestPayment,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setIsCardPaymentFlag,
    setOverPayedAmount,
    setAmount,
    paymentModalInputRef,
    filteredPaymentMethods,
    isShowingAll,
    showMoreItems,
    showPreviousItems,
    selectedCustomer,
    setSelectedCustomer,
    handleDeletePayment,
    setTillLink,
    tillLink,
    fetchWalletData,
    isWalletFlag,
    setIswalletFlag,
    isNewGiftCardFlag,
    setIsNewGiftCardFlag,
    giftCardMode,
    setIsRefundWalletOpen,
    isRefundWalletOpen,
    isBankTransferOpen,
    setIsBankTransferOpen,
    realPrice,
    setRealPrice,
    PaymentMethods,
    getFilteredPaymentMethods,
    setDisplayCustomerSearch,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
    pendingRefundCustomer,
    displayCustomerSearch,
    showReturnOptions,
    setShowReturnOptions,
    isBlindReceiptPending,
    setIsBlindReceiptPending,
    setLoading,
    setIsPurchaseReturn,
    setStartRowData,
    setIsInputFocused,
    addSelectedReturnProductsToCart,
    selectedReturnType,
    setSelectedReturnType,
    deleteReceipt,
    tillDataPaymentMethods,
    handlePayment,
    setCardPaymnetError,
    setShowCardPaymnteModal,
    isOnline,
    setNumb,
    setPaymentType,
    filterDrawer,
    setFilterDrawer,
    financialDocs,
    setFinancialDocs,
    financialDocument,
    setFinancialDocument,
    compressImage,
    financialForm,
    financialDocUploaded,
    setFinancialDocUploaded,
    isValidAmount,
    bankTransferContext,
    setBankTransferContext,
    selectedReturnOrder,
    currentCardInput,
    setCurrentCardInput,
    enterTotalQtyForWallet,
    currentCashInput,
    setCurrentCashInput,
    currentUPIInput,
    setCurrentUPIInput,
    dynamicPaymentInput,
    setDynamicPaymentInput,
    topupAmount,
    setTopupAmount,
    cashTendered,
    setCashTendered,
    matchedPayments,
    isProcessingTopup,
    setIsProcessingTopup,
    autoFillEnterAmount,
    showRefundModal,
    setShowRefundModal,
    handleWalletRefundComplete,
    handleWalletTopUp,
    currenciesList,
    showTopupModal,
    setShowTopupModal,
    showCardAmountInput,
    setShowCardAmountInput,
    cardPaymentForm,
    showGiftCardTopup,
    setShowGiftCardTopup,
    handleEnterTopup,
    giftCardTopupAmount,
    setGiftCardTopupAmount,
    giftCardTopupPaymentMethod,
    setGiftCardTopupPaymentMethod,
    giftCardTopupCashInput,
    setGiftCardTopupCashInput,
    giftCardTopupCardInput,
    setGiftCardTopupCardInput,
    giftCardTopupUPIInput,
    setGiftCardTopupUPIInput,
    giftCardGenericInput,
    setGiftCardGenericInput,
    currentPaymentInput,
    giftCardTotalPaid,
    currSymbol,
    currSymbolRight,
    giftCardAutoFillAmount,
    finalizeGiftCardTopup,
    giftCardMatchedPayments,
    giftCardNumber,
    setGiftCardNumber,
    giftCardPin,
    setGiftCardPin,
    resetGiftCardTopup,
    handleCheckGiftCardBalance,
    giftCardTopupPaymentPage,
    setGiftCardTopupPaymentPage,
    giftCardTopupFocusedField,
    setGiftCardTopupFocusedField,
    giftCardTopupDenomKeyboard,
    setGiftCardTopupDenomKeyboard,
    giftCardTopupShowCardAmountInput,
    setGiftCardTopupShowCardAmountInput,
    giftCardTopupCardForm,
    isCheckingBalance,
    setIsCheckingBalance,
    rawGiftCardPayments,
    giftCardBalance,
    setGiftCardBalance,
  } = props;

  const tillData = useAuthStore((s) => s.tillData);
  const [redeemAmount, setRedeemAmount] = useState(() => {
    return !isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00";
  });

  // Wallet OTP state — managed here and passed down to WalletOtpModal
  const [showWalletOtpModal, setShowWalletOtpModal] = useState(false);
  const [walletOtpAmount, setWalletOtpAmount] = useState(0);

  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const transactionStoreData = JSON.parse(localStorage.getItem("transactionStore") || "{}");
  const persistedReturnType = transactionStoreData?.state?.selectedReturnType;
  useEffect(() => {
    // Only proceed if setCustomersData function is available
    if (typeof setCustomersData === "function") {
      if (!customersData) {
        if (cart?.customer) {
          const initialCustomer = {
            ...cart.customer,
            currentBalance: cart.customer.currentBalance || 0,
            totalSpent: cart.customer.totalSpent || 0,
            joinDate: cart.customer.joinDate || new Date().toISOString(),
            transactions: cart.customer.transactions || [],
          };
          setCustomersData([initialCustomer]);
        } else {
          setCustomersData([]);
        }
      } else if (!Array.isArray(customersData) && typeof customersData === "object") {
        setCustomersData([customersData]);
      }
    }
  }, [cart?.customer]);

  useEffect(() => {
    if (typeof setCart !== "function") {
      console.warn("setCart is not a function. Ensure it is passed as a prop from the parent component.");
      return;
    }
    if (!cart) {
      const initialCart = { payments: [], paid: 0, items: [], total: 0, customer: null };
      setCart(initialCart);
    } else if (!cart.payments) {
      // F-07: also clear paymentReferenceData — spreading ...cart otherwise carries
      // any stale reference data (cheque number, UTR, card last-4) into the next bill.
      const updatedCart = { ...cart, payments: [], paid: cart.paid || 0, paymentReferenceData: {} };
      setCart(updatedCart);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!cart, !cart?.payments]);

  useEffect(() => {
    if (isWalletFlag) {
      setRedeemAmount(!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00");
    } else {
      setRedeemAmount("");
    }
  }, [isWalletFlag, amount]);

  // handleDocumentClick used by the Document Type modal below
  const handleDocumentClick = (type) => {
    if (type === "Invoice") {
      // BUG-2173: switching from Advance to Invoice while an active Advance Item
      // (productSegment "AD", weight > 0) is still in the cart must be blocked with
      // this popup instead of silently converting the order.
      const hasBlockingAdvanceItem = cart?.items?.some((item) => item?.productSegment === "AD" && item?.weight > 0);
      if (hasBlockingAdvanceItem) {
        Modal.warning({
          title: messages.errors.cart.advance_item_blocks_invoice_title,
          content: messages.errors.cart.advance_item_blocks_invoice,
          okText: "Ok",
        });
        return;
      }
      setShowDocumentPopup(false);
      setSelectedDocumentType("Invoice");
      cart.layAway = "N";
      setCart(cart);
    } else if (type === "Advance") {
      if (selectedSaleTypeData?.cwrSaletype?.enableLayaway === "Y") {
        const requireCustomer = posConfig?.requireCustomerforLayaway === "Y" ? tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== cart.customer.cwrCustomerId : true;
        if (requireCustomer) {
          if (cart.items.length > 0 || posConfig?.enableItemRestrictionForAdvance !== "Y") {
            if (!cart.isReturn) {
              if (cart.paid === 0) {
                if (posConfig?.advanceLayaway === "Y") {
                  setShowDocumentPopup(false);
                  upsertPOSLog(cart, "LAY");
                  cart.layAway = "Y";
                  setCart(cart);
                  const payments =
                    showPayments.length >= 5
                      ? sortBy(showPayments, "sequenceNo").slice(
                          0,
                          tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === cart.customer.cwrCustomerId && showPayments.length === 6 ? 4 : 4
                        )
                      : showPayments;
                  setSelectedDocumentType("Advance");
                  setStartIndex(payments.length);
                  setShowPayments(payments);
                  setShowPaymentMethods(true);
                } else {
                  setShowDocumentPopup(false);
                  upsertPOSLog(cart, "LAY");
                  processOrder("layaway");
                }
              }
            } else {
              message.error("Advance not supported for return orders");
            }
          } else {
            message.error("Please add items before advance");
          }
        } else {
          message.warning("Please select a customer to proceed");
        }
      } else {
        message.error("Advance not enabled");
      }
    } else if (type === "Quotation") {
      if (posConfig?.enableQuotation === "Y") {
        setShowDocumentPopup(false);
        setSelectedDocumentType("Quotation");
        cart.isQuotation = true;
        setCart(cart);
      }
    }
  };

  return (
    <Fragment>
      {/* Sales Rep Drawer */}
      {openSalesRep && (
        <SalesRepDrawer
          openSalesRep={openSalesRep}
          setOpenSalesRep={setOpenSalesRep}
          cart={cart}
          setCart={setCart}
          posConfig={posConfig}
          keyboardType={keyboardType}
          setKeyboardType={setKeyboardType}
          salesRepValue={salesRepValue}
          setSalesRepValue={setSalesRepValue}
          selectedProductInCart={selectedProductInCart}
          searchInputRef={searchInputRef}
        />
      )}

      {/* Stock Confirmation Drawer */}
      {isStockModal && (
        <StockConfirmationDrawer
          isStockModal={isStockModal}
          setIsStockModal={setIsStockModal}
          cart={cart}
          tempCart={tempCart}
          setTempCart={setTempCart}
          addProduct={addProduct}
          deleteProduct={deleteProduct}
          deleteCart={deleteCart}
          handleCartTotalClick={handleCartTotalClick}
          themeJSON={themeJSON}
        />
      )}

      {/* Document Type select Modal */}
      {showDocumentPopup && (
        <Modal
          open={true}
          closable={true}
          onCancel={() => setShowDocumentPopup(false)}
          keyboard={false}
          footer={null}
          width="33%"
          centered
          styles={{ body: { padding: 10, backgroundColor: "#F3F4F9" } }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "4vh 2.5vw" }}>
            {documentTypes
              ?.filter((doc) => doc.type !== selectedDocumentType)
              ?.map((doc) => {
                return (
                  doc.isVisible && (
                    <Button
                      key={doc.type}
                      style={{
                        height: "9vh",
                        borderRadius: "5px",
                        cursor: doc.isEnabled ? "pointer" : "not-allowed",
                        backgroundColor: "#2F3856",
                        color: "#fff",
                        fontSize: "1.1rem",
                        border: "1px solid #2F3856",
                        textAlign: "center",
                        fontWeight: 400,
                      }}
                      onClick={() => doc.isEnabled && handleDocumentClick(doc.type)}
                    >
                      {doc.type}
                    </Button>
                  )
                );
              })}
          </div>
        </Modal>
      )}

      {/* Customer Wallet Drawer */}
      {showCustomerWallet && (
        <CustomerWalletDrawer
          showCustomerWallet={showCustomerWallet}
          setShowCustomerWallet={setShowCustomerWallet}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          customersData={customersData}
          setCustomersData={setCustomersData}
          showPayments={showPayments}
          setShowPayments={setShowPayments}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          posConfig={posConfig}
          cart={cart}
          setCart={setCart}
          currenciesData={currenciesData}
          denaminationsKeyboard={denaminationsKeyboard}
          setDenaminationsKeyboard={setDenaminationsKeyboard}
          filteredPaymentMethods={filteredPaymentMethods}
          requestPayment={requestPayment}
          fetchWalletData={fetchWalletData}
          themeJSON={themeJSON}
          currenciesList={currenciesList}
          pricePrecision={pricePrecision}
          setIsBankTransferOpen={setIsBankTransferOpen}
          setBankTransferContext={setBankTransferContext}
          enterTotalQtyForWallet={enterTotalQtyForWallet}
          currentCardInput={currentCardInput}
          setCurrentCardInput={setCurrentCardInput}
          topupAmount={topupAmount}
          setTopupAmount={setTopupAmount}
          showRefundModal={showRefundModal}
          setShowRefundModal={setShowRefundModal}
          handleWalletRefundComplete={handleWalletRefundComplete}
          currentUPIInput={currentUPIInput}
          setCurrentUPIInput={setCurrentUPIInput}
          showTopupModal={showTopupModal}
          setShowTopupModal={setShowTopupModal}
        />
      )}

      {/* Refund Wallet Drawer */}
      {(isRefundWalletOpen || persistedReturnType === "STORE_CREDIT") && (
        <RefundWalletDrawer
          isRefundWalletOpen={isRefundWalletOpen}
          setIsRefundWalletOpen={setIsRefundWalletOpen}
          selectedReturnType={selectedReturnType}
          selectedPaymentMethod={selectedPaymentMethod}
          cart={cart}
          currenciesList={currenciesList}
          requestPayment={requestPayment}
          processOrder={processOrder}
          setDisplayCustomerSearch={setDisplayCustomerSearch}
          pendingRefundCustomer={pendingRefundCustomer}
          filterDrawer={filterDrawer}
          setSelectedReturnType={setSelectedReturnType}
          deleteReceipt={deleteReceipt}
        />
      )}

      {/* Wallet OTP Modal */}
      {showWalletOtpModal && (
        <WalletOtpModal
          showWalletOtpModal={showWalletOtpModal}
          setShowWalletOtpModal={setShowWalletOtpModal}
          walletOtpAmount={walletOtpAmount}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          selectedPaymentMethod={selectedPaymentMethod}
          requestPayment={requestPayment}
          setIswalletFlag={setIswalletFlag}
          setRedeemAmount={setRedeemAmount}
          cart={cart}
        />
      )}

      {/* Return Options Modal */}
      {showReturnOptions && (
        <ReturnOptionsModal
          showReturnOptions={showReturnOptions}
          setShowReturnOptions={setShowReturnOptions}
          selectedReturnType={selectedReturnType}
          setSelectedReturnType={setSelectedReturnType}
          cart={cart}
          setCart={setCart}
          posConfig={posConfig}
          setLoading={setLoading}
          setIsPurchaseReturn={setIsPurchaseReturn}
          setStartRowData={setStartRowData}
          setIsInputFocused={setIsInputFocused}
          addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
          tillDataPaymentMethods={tillDataPaymentMethods}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          setIsRefundWalletOpen={setIsRefundWalletOpen}
          setFilterDrawer={setFilterDrawer}
          selectedReturnOrder={selectedReturnOrder}
          isBlindReceiptPending={isBlindReceiptPending}
          setIsBlindReceiptPending={setIsBlindReceiptPending}
        />
      )}

      {/* Wallet Redeem Drawer */}
      {isWalletFlag && (
        <WalletRedeemDrawer
          isWalletFlag={isWalletFlag}
          setIswalletFlag={setIswalletFlag}
          amount={amount}
          cart={cart}
          posConfig={posConfig}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          requestPayment={requestPayment}
          currenciesList={currenciesList}
          showPayments={showPayments}
          setShowPayments={setShowPayments}
          setStartIndex={setStartIndex}
          getFilteredPaymentMethods={getFilteredPaymentMethods}
        />
      )}

      {/* Gift Card Drawer */}
      {isNewGiftCardFlag && (
        <GiftCardDrawer
          isNewGiftCardFlag={isNewGiftCardFlag}
          setIsNewGiftCardFlag={setIsNewGiftCardFlag}
          cart={cart}
          posConfig={posConfig}
          currenciesList={currenciesList}
          currenciesData={currenciesData}
          showPayments={showPayments}
          setShowPayments={setShowPayments}
          setStartIndex={setStartIndex}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          requestPayment={requestPayment}
          getFilteredPaymentMethods={getFilteredPaymentMethods}
          themeJSON={themeJSON}
          giftCardMode={giftCardMode}
          handleEnterTopup={handleEnterTopup}
          giftCardTopupUPIInput={giftCardTopupUPIInput}
          setGiftCardTopupUPIInput={setGiftCardTopupUPIInput}
          giftCardTopupAmount={giftCardTopupAmount}
          setGiftCardTopupAmount={setGiftCardTopupAmount}
          giftCardTopupPaymentMethod={giftCardTopupPaymentMethod}
          setGiftCardTopupPaymentMethod={setGiftCardTopupPaymentMethod}
          giftCardTopupCashInput={giftCardTopupCashInput}
          setGiftCardTopupCashInput={setGiftCardTopupCashInput}
          giftCardTopupCardInput={giftCardTopupCardInput}
          setGiftCardTopupCardInput={setGiftCardTopupCardInput}
          showGiftCardTopup={showGiftCardTopup}
          setShowGiftCardTopup={setShowGiftCardTopup}
          giftCardNumber={giftCardNumber}
          setGiftCardNumber={setGiftCardNumber}
          giftCardBalance={giftCardBalance}
          setGiftCardBalance={setGiftCardBalance}
        />
      )}

      {/* Bank Transfer Drawer */}
      {isBankTransferOpen && (
        <BankTransferDrawer
          open={isBankTransferOpen}
          onClose={() => {
            setIsBankTransferOpen(false);
            setBankTransferContext(null);
            setSelectedPaymentMethod({});
          }}
          context={bankTransferContext}
          selectedPaymentMethod={bankTransferContext?.paymentMethod || selectedPaymentMethod}
          amount={(() => {
            const isWalletFlow = bankTransferContext?.type === "wallettopup" || bankTransferContext?.type === "walletrefund";
            if (isWalletFlow && bankTransferContext?.amount) {
              const totalPaid = matchedPayments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
              return Math.max(0, parseFloat(bankTransferContext.amount) - totalPaid).toFixed(pricePrecision);
            }
            return bankTransferContext?.amount || amount;
          })()}
          pricePrecision={tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision}
          onSubmit={async (bankData) => {
            const pm = bankTransferContext?.paymentMethod || selectedPaymentMethod;
            const enrichedPm = { ...pm, ...bankData };
            setSelectedPaymentMethod(enrichedPm);
            setIsBankTransferOpen(false);
            const isWalletFlow = bankTransferContext?.type === "wallettopup" || bankTransferContext?.type === "walletrefund";
            const isRefund = bankTransferContext?.type === "walletrefund";
            const btAmount = bankTransferContext?.amount;
            setBankTransferContext(null);
            if (isWalletFlow && btAmount) {
              const totalPaid = matchedPayments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
              const remaining = Math.max(0, parseFloat(btAmount) - totalPaid);
              const userEnteredAmount = bankData.amount != null ? parseFloat(bankData.amount) : remaining;
              const paymentAmount = Math.min(userEnteredAmount, remaining);
              if (paymentAmount <= 0) {
                message.warning("Payment amount exceeds remaining amount");
                setIsProcessingTopup(false);
                return;
              }
              setIsProcessingTopup(true);
              try {
                await requestPayment(enrichedPm, paymentAmount.toFixed(pricePrecision), undefined, true);
                const updatedTotalPaid = totalPaid + paymentAmount;
                setDynamicPaymentInput("");
                if (updatedTotalPaid >= parseFloat(btAmount)) {
                  if (isRefund) {
                    await handleWalletRefundComplete(parseFloat(topupAmount || btAmount));
                  } else {
                    await handleWalletTopUp(topupAmount || btAmount);
                  }
                  setIsProcessingTopup(false);
                } else {
                  const remainAfter = parseFloat(btAmount) - updatedTotalPaid;
                  setDynamicPaymentInput(remainAfter.toFixed(pricePrecision));
                  message.success(`${pm.name} payment of ${paymentAmount.toFixed(pricePrecision)} added. Remaining: ${remainAfter.toFixed(pricePrecision)}`);
                  setIsProcessingTopup(false);
                }
              } catch (error) {
                console.error("Bank transfer wallet payment error:", error);
                setIsProcessingTopup(false);
              }
            } else if (isWalletFlow) {
              enterTotalQtyForWallet();
            } else {
              handlePayment({
                selectedPaymentMethod: enrichedPm,
                cart,
                amount: bankData.amount != null ? bankData.amount.toString() : amount,
                posConfig,
                tillData,
                isOnline,
                showConfirm,
                requestPayment,
                processOrder,
                setShowCardPaymnteModal,
                setPaymentType,
                setCardPaymnetError,
                setNumb,
              });
            }
          }}
        />
      )}
    </Fragment>
  );
};

export default PointOfSuperMarketModals;
